module.exports = __webpack_public_path__ + "static/media/wix.441d9fd2.svg";